module.exports = __webpack_public_path__ + "img/TeamComic_067.0777baa4.png";